<div
   [ngClass]="
      (isDropListEntered$ | async)
         ? 'sam-full-width sam-full-height button-hover'
         : 'sam-full-width sam-full-height button-no-hover'
   "
   (dragenter)="dropListEntered($event)"
   (dragleave)="dropListExited()"
>
   <kendo-uploaddropzone
      zoneId="fileZone"
      class="sam-full-width sam-full-height drop-button"
      (click)="onUploadButtonClick(upload)"
      (drop)="onDrop()"
   >
      <div class="sam-center sam-form-flex-row sam-full-width sam-full-height">
         <div>
            <fa-icon [fixedWidth]="true" [icon]="uploadIcon"></fa-icon>
         </div>
         <div class="sam-margin-left">
            {{ 'common.settings.agent_greetings.upload_audio' | translate }}
         </div>
      </div>
   </kendo-uploaddropzone>

   <kendo-upload
      class="sam-display-none"
      #upload
      (select)="onSelect($event)"
      zoneId="fileZone"
      [multiple]="true"
      [restrictions]="fileRestrictions"
      accept="audio/mp3,audio/wav"
   >
   </kendo-upload>
</div>
